import React from 'react'
import {ReactComponent as ArrowRight} from '../../assets/icons/arrow-right.svg'
const ArrowRightIcon = () => {
    return (
        <div>
            <ArrowRight />
        </div>
    )
}

export default ArrowRightIcon
